import { BackgroundColor } from '@ampcore/ampcom-contracts'

export const loginBannerBackgroundColors = [
  BackgroundColor.MIDNIGHT_BLUE,
  BackgroundColor.DARK_MINT,
  BackgroundColor.MINT,
  BackgroundColor.LIGHT_BLUE,
  BackgroundColor.LIGHT_LIME,
  BackgroundColor.LIGHT_MINT,
  BackgroundColor.LIGHT_PURPLE,
  BackgroundColor.PURPLE,
  BackgroundColor.STONE
] as const

export type LoginBannerBackgroundColor =
  (typeof loginBannerBackgroundColors)[number]
